import { getDirectusField } from "directus/src/operations";
import { useQuery } from "@tanstack/react-query";

export const useStatuses = ({ collection, remove, sort = false }) => {
  return useQuery({
    queryKey: [collection, "status", "tab"],
    queryFn: async () => {
      const response = await getDirectusField(collection, "status");

      let data = response.meta.options.choices.map((status) => ({
        label: status.text,
        value: status.value,
      }));

      if (sort) {
        data.sort((a, b) => b.value.localeCompare(a.value));
      }
      return data || [];
    },
    select: (data) =>
      remove ? data.filter((status) => !remove.includes(status.value)) : data,
  });
};
